<template>
  <div class="horizontal-donut-chart-widget custom-widget">
    <div class="header">
        <span class="is-bold"> {{title}} </span>
        <span class="is-bold"> {{$t('statistics.total', {total})}} </span>
    </div>

    <div class="body">
      <div v-if="hasData" class="data-wrapper">
        <div class="labels-wrapper">
          <div v-for="index in labels.length" :key="index">
            <span class="dataset-label-color" :style="`background-color: ${datasetColors[index - 1]}`"></span>
            <span class="dataset-label">{{labels[index - 1]}}</span>
            &nbsp;
            <span class="dataset-label-info">({{datasetData[index - 1]}}<span class="d-none d-xl-inline-block">- {{percentage(datasetData[index - 1], total).toFixed(2)}}%</span>)</span>
          </div>
        </div>
        <div class="chart-wrapper">
          <va-chart class="chart" :data="data" :options="chartOptions" type="donut"/>
        </div>
      </div>
      <div v-else class="no-data-wrapper">
        <h6><b>{{ $t('horizontalDonutChartWidget.no_data_for_chart') }}</b></h6>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    options: {
      required: false,
    },
    data: {
      required: true
    },
  },
  computed: {
    datasetData: function () {
      if (this.data !== undefined) {
        return this.data.datasets[0].data
      }
    },
    datasetColors: function () {
      if (this.data !== undefined) {
        return this.data.datasets[0].backgroundColor
      }
    },
    labels: function () {
      if (this.data !== undefined) {
        return this.data.labels
      }
    },
    total: function () {
      return this.datasetData !== undefined ? this.datasetData.reduce((cummulative, value) => cummulative + value, 0) : 0
    },
    hasData: function () {
      return this.data !== undefined && this.data !== null && this.total > 0
    },
    chartOptions: function () {
      let options = {
        cutoutPercentage: 70,
        legend: {
          display: false
        },
        tooltips: {
          bodyFontSize: 14,
          bodyFontFamily: 'sans-serif'
        },
        responsive: true,
        maintainAspectRatio: true
      }
      if (this.options !== undefined && this.options !== null) {
        Object.assign(options, this.options)
      }
      return options
    }
  },
  methods: {
    percentage: function (count, total) {
      return count / total * 100
    },
  }
}
</script>

<style lang="scss" scoped>

$card-color: #F0F0F0;
$primary-dark-gray: #48494B;

.horizontal-donut-chart-widget {
  padding: 1rem;
  background-color: $card-color;

  .header {
    color: $primary-dark-gray;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    border-bottom: solid 2px #d3d3d3;
  }

  .data-wrapper {
    display: flex;
    justify-content: space-between;
    margin-left: 0.5rem;
    padding-top: 1rem;
    padding-bottom: 2rem;
  }

  .dataset-label-color {
    display: inline-block;
    width: 0.9rem;
    height: 0.9rem;
    border-radius: 0.45rem;
    margin-right: 0.5em
  }

  .dataset-label {
    font-size: 0.85rem;
    font-weight: 300;
  }

  .dataset-label-info {
    font-size: 0.9rem;
    font-weight: 300;
  }

  .dataset-label, .dataset-label-info {
    color: #6d767f;
  }

  .chart-wrapper {
    max-width: 25%;
    margin-top: 1rem;
    margin-bottom: 0.4rem;
    margin-right: 7.5%;
  }

  .labels-wrapper {
    width: 50%;
    max-width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1rem 0;
  }

  .no-data-wrapper {
    width: 100%;
    min-height: 140px;
    max-width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  @media only screen and (max-width: 768px) {
    .data-wrapper {
      flex-direction: column;
    }

    .labels-wrapper, .no-data-wrapper {
      width: 100%;
      max-width: 100%;
    }

    .chart-wrapper {
      width: 80%;
      max-width: 80%;
      margin-top: 1rem;
      margin-left: 10%;
    }

    .labels-wrapper {
      margin-top: 1rem;
    }

    .header {
      flex-direction: column;
      text-align: center;
    }
  }
}

.custom-widget {
  height: calc(100% - 24px);
}

</style>
